import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import SubjectsPage from "./pages/SubjectsPage";
import SubjectsMock from "./pages/SubjectsMock";
import MockTestPage from "./pages/MockTestPage";
import MockTestList from "./pages/MockTestList";
import TestList from "./pages/TestList";
import SolutionPage from "./pages/SolutionPage";
import ViewSolution from "./pages/ViewSolution";
import DownloadPDFPage from "./pages/DownloadPDFPage";
import About from "./pages/About";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function App() {
  return (
    <BrowserRouter>
      

        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/subjects" element={<SubjectsPage />} />
          <Route path="/subject" element={<SubjectsMock />} />
          <Route path="/mocktests/:subjectId" element={<MockTestList />} />
          <Route path="/mocktest/:test_id" element={<MockTestPage />} />
          <Route path="/test/:subjectId" element={<TestList />} />
          <Route path="/solution/:testId" element={<SolutionPage />} />
          <Route path="/view-solution" element={<ViewSolution />} />
          <Route path="/download-pdf" element={<DownloadPDFPage />} />
             <Route path="/about" 
               element={<About />} />
      
      
        </Routes>
      

      
    </BrowserRouter>
  );
}